module.exports = __webpack_public_path__ + "static/media/zingers.f1665b22.png";